import { useGetConsultantDocumentTypesQuery } from "@bonliva-crm/graphql";
import locale from "@bonliva-crm/locale";
import { FileUpload, Loader, SingleSelect } from "@bonliva-crm/ui";
import { Button, Paper } from "@material-ui/core";
import cns from "classnames";
import { useStyles } from "../styles";
import { useFileUploader } from "../use-file-uploader";
import { uniq } from "lodash";

type Props = {
  consultantId: string;
};

export function FileUploader({ consultantId }: Props) {
  const classes = useStyles();

  const { loading, data } = useGetConsultantDocumentTypesQuery({
    variables: { id: consultantId }
  });

  const {
    fileUploadResetCount,
    onFileUpload,
    onFileRemove,
    documentType,
    setDocumentType,
    submitFiles,
    submitFilesData,
    clearFiles,
    files
  } = useFileUploader({
    consultantId
  });

  if (loading && !data) {
    return (
      <Paper
        className={cns(
          classes.padding20,
          classes.borderRadius2,
          classes.fileUploadWrapper
        )}
      >
        <Loader />
      </Paper>
    );
  }

  return (
    <Paper
      className={cns(classes.padding20, classes.borderRadius2, classes.fileUploadWrapper)}
    >
      <FileUpload
        key={fileUploadResetCount}
        onFileUpload={onFileUpload}
        onFileRemove={onFileRemove}
        multipleUploads
      />
      <div className={classes.documentTypeWrapper}>
        <SingleSelect
          placeholder=""
          inputLabel={locale.ChooseDocumentType}
          value={{
            label: documentType,
            value: documentType
          }}
          onChange={(e) => setDocumentType(e.value)}
          styleProps={{ control: { showBorder: true }, menu: { showBorder: true } }}
          options={uniq([
            ...(data?.consultantById?.DocumentTypes ?? []),
            ...Object.values(locale.bookingWeekConsultantDocumentWithOutBookingType)
          ])
            .sortBy((x) => x)
            .map((dt) => ({
              label: dt,
              value: dt
            }))}
          isClearable={true}
        />
      </div>
      <div className={classes.buttonWrapper}>
        <Button color="primary" variant="outlined" onClick={() => clearFiles()}>
          {locale.Cancel}
        </Button>
        <Button
          color="primary"
          variant="contained"
          disabled={files.length < 1 || submitFilesData.loading}
          onClick={() => submitFiles()}
        >
          {locale.Upload}
        </Button>
      </div>
    </Paper>
  );
}
